import React from "react";
import { Group, Select, TextInput } from "@mantine/core";

type Props = {
    search: string;
    statusFilter: string | null;
    onSearchChange: (value: string) => void;
    onStatusFilterChange: (value: string | null) => void;
    language: "en" | "da";
};

export default function BookingFilters({
    search,
    statusFilter,
    onSearchChange,
    onStatusFilterChange,
    language,
}: Props) {
    const isEn = language === "en";

    return (
        <Group grow align="flex-end">
            <TextInput
                label={isEn ? "Search" : "Søg"}
                placeholder={
                    isEn
                        ? "Search booking, hotel, country, contact..."
                        : "Søg booking, hotel, land, kontakt..."
                }
                value={search}
                onChange={(e) => onSearchChange(e.currentTarget.value)}
            />

            <Select
                label="Status"
                value={statusFilter}
                onChange={onStatusFilterChange}
                data={[
                    { value: "all", label: isEn ? "All statuses" : "Alle statusser" },
                    { value: "pendingapproval", label: isEn ? "Pending approval" : "Afventer godkendelse" },
                    { value: "awaitingpayment", label: isEn ? "Awaiting payment" : "Afventer betaling" },
                    { value: "paid", label: isEn ? "Paid" : "Betalt" },
                    { value: "roomassignmentopen", label: isEn ? "Rooming list open" : "Rooming list åben" },
                    { value: "completed", label: isEn ? "Completed" : "Afsluttet" },
                    { value: "rejected", label: isEn ? "Rejected" : "Afvist" },
                    { value: "cancelled", label: isEn ? "Cancelled" : "Annulleret" },
                ]}
            />
        </Group>
    );
}
